import OptionInterface from './interfaces/option.interface';

export const SECTION_CODE_CUISINE = 'SCU';

export const ASSEMBLY_DELIVERY_DATES: OptionInterface[] = [
  { label: 'Dimanche 31 janvier 2027', value: '2027-01-31' },
  { label: 'Lundi 1er février 2027', value: '2027-02-01' },
  { label: 'Mardi 2 février 2027', value: '2027-02-02' },
  { label: 'Mercredi 3 février 2027', value: '2027-02-03' },
];

export const CUISINE_ASSEMBLY_DELIVERY_DATES: OptionInterface[] = [
  { label: 'Samedi 30 janvier 2027', value: '2027-01-30' },
  { label: 'Dimanche 31 janvier 2027', value: '2027-01-31' },
  { label: 'Lundi 1er février 2027', value: '2027-02-01' },
  { label: 'Mardi 2 février 2027', value: '2027-02-02' },
  { label: 'Mercredi 3 février 2027', value: '2027-02-03' },
];

export const DISASSEMBLY_DELIVERY_DATES: OptionInterface[] = [
  { label: 'Dimanche 7 février 2027 de 17h à 23h', value: '2027-02-07' },
  { label: 'Lundi 8 février 2027 de 7h à 17h', value: '2027-02-08' },
];
